export enum EventName {
  NERDUP_LEAD = 'nerdup_lead',
  FEATURE_VIEWED = 'Feature Viewed',
  SKU_VIEWED = 'SKU Viewed',
  SHOPPING_FINISHED = 'Shopping Finished',
  LINK_VIEWED = 'link_viewed',
  FEATURE_INTERACTED = 'feature_interacted',
}

export interface BaseEvent {
  deployable_name: string;
  deployable_version: string;
  traditional_device_id: string;
}

export interface BaseShoppingEvent {
  sku_id?: string;
  sku_source?: 'marketplace' | 'plinko' | 'treehouse';
  sku_name?: string;
  sku_product_type?: string;
  sku_level?: 'institution' | 'offer' | 'product';
  institution_id?: string;
  institution_name?: string;
  product_id?: string;
  product_name?: string;
  offer_id?: string;
  offer_name?: string;
  monetizable?:
    | 'yes_assumed'
    | 'no'
    | 'no_because_of_limit'
    | 'no_because_of_lead'
    | 'no_because_of_lead_form'
    | 'no_because_of_details';
  entry_point_pageview_id?: string;
  entry_point_page_url?: string;
  entry_point_page_name?: string;
  impression_pageview_id?: string;
  impression_page_url?: string;
  impression_page_name?: string;
  impression_section?: string;
  impression_position?: number;
  sku_impression_id: string;
  additional_attributes?: Record<string, unknown>;
}

export type Event<T> = BaseEvent & T;

export type PagePayload = Event<{
  pageview_id: string;
  content_id?: string | number;
  content_source?: 'wp';
  path?: string;
  url?: string;
  referrer?: string;
  page_branch_name?: string;
  page_funnel_step?: number;
}>;

export type FeatureViewedPayload = Event<{
  activity_id?: string;
  parent_activity_id?: string;
  entity_name: string;
  entity_section?: string;
  impression_page_url?: string;
  impression_pageview_id?: string;
  impression_position?: number | null;
  additional_attributes?: Record<string, unknown>;
}>;

export type NerdupLeadPayload = Event<{
  pageview_id: string;
  utm_source?: string;
  utm_campaign?: string;
  utm_medium?: string;
  utm_term?: string;
  utm_content?: string;
  s1?: string;
  s2?: string;
  s3?: string;
}>;

export type LinkViewedPayload = Omit<
  Event<{
    destination_url: string;
    entity_name: string;
    event_id: string;
    impression_pageview_id?: string;
    impression_page_url?: string;
    link_copy: string;
  }>,
  'traditional_device_id'
>;

export type SkuViewedPayload = Event<BaseShoppingEvent>;

export type ShoppingFinishedPayload = Event<
  BaseShoppingEvent & {
    shopping_finish_id: string;
    sub_id_alias?: string;
    finish_type: 'external_application' | 'internal_content' | 'lead_inputflow';
    destination_url: string;
    cta_type?: string;
    revenue_amount?: string | number;
    revenue_type?: 'ingested' | 'estimated';
    interstitial_client_bot_suspected?: boolean;
    estimated_revenue?: number;
  }
>;

export type EventPayload<T extends EventName> = T extends EventName.SKU_VIEWED
  ? SkuViewedPayload
  : T extends EventName.SHOPPING_FINISHED
    ? ShoppingFinishedPayload
    : never;
